var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.items)?_c('div',{staticClass:"accordions-comp"},_vm._l((_vm.items),function(item,index){return _c('AccordionCard',{key:((_vm.$route.name) + "_accordion_" + index),attrs:{"item":item,"id":_vm.idIndex  + '_' + index}})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }